import { batch } from '@preact/signals-react'
import { Preview } from '@susu/headless-commerce/features/configurator/domain/Preview/Preview'
import type { PreviewDataAccessObject } from '@susu/headless-commerce/features/configurator/domain/Preview/PreviewDataAccessObject'

export class PreviewEncoder {
  static encode(instance: Preview): PreviewDataAccessObject {
    return {
      imageProductIds: {
        layeredImage: instance.imageProductIds.value.layeredImage.value,
        staticImage: instance.imageProductIds.value.staticImage.value,
      },
      imageURL: instance.imageURL.value,
      imageSourceSets: {
        desktopSrcSet: instance.imageSourceSets.value.desktopSrcSet.value,
        mobileSrcSet: instance.imageSourceSets.value.mobileSrcSet.value,
        tabletSrcSet: instance.imageSourceSets.value.tabletSrcSet.value,
      },
      layeredPreviewPosition: {
        focalPoint: instance.layeredPreviewPosition.value.focalPoint.value,
        zoom: instance.layeredPreviewPosition.value.zoom.value,
      },
      previewData: {
        productIds: instance.previewData.value.productIds.value,
        staticImage: instance.previewData.value.staticImage.value,
      },
    }
  }

  static decode(properties: PreviewDataAccessObject) {
    const instance = new Preview()

    batch(() => {
      instance.imageProductIds.value.layeredImage.value =
        properties.imageProductIds.layeredImage
      instance.imageProductIds.value.staticImage.value =
        properties.imageProductIds.staticImage
      instance.imageURL.value = properties.imageURL
      instance.imageSourceSets.value.desktopSrcSet.value =
        properties.imageSourceSets.desktopSrcSet
      instance.imageSourceSets.value.mobileSrcSet.value =
        properties.imageSourceSets.mobileSrcSet
      instance.imageSourceSets.value.tabletSrcSet.value =
        properties.imageSourceSets.tabletSrcSet
      instance.layeredPreviewPosition.value.focalPoint.value =
        properties.layeredPreviewPosition.focalPoint
      instance.layeredPreviewPosition.value.zoom.value =
        properties.layeredPreviewPosition.zoom
      instance.previewData.value.productIds.value =
        properties.previewData.productIds
      instance.previewData.value.staticImage.value =
        properties.previewData.staticImage
    })

    return instance
  }
}
